async function fetchIPDetails() {
    try {
        // Fetch IP address
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        const ipAddress = data.ip;

        // Fetch location and time zone based on IP address
        // const locationData = await fetchData(`https://ipapi.co/${ipAddress}/json/`);
        const locationData = await fetchData(`https://ipapi.co/${ipAddress}/json/`);

        console.log("locationData", locationData)

        // Log IP address, location, and time zone to console
        // console.log("IP Address:", ipAddress);
        // console.log("Location:", locationData.city, locationData.region, locationData.country_name);
        // console.log("Time Zone:", locationData.timezone);

        // Call getUserCurrentAddress to display user's address based on IP
        const time = await getUserCurrentAddress(locationData);
        // console.log('timeeeeeeee',time)
        const location = `${time}, ${locationData.city}, ${locationData.region}, ${locationData.country_name}, ${locationData.timezone}, ${ipAddress}`;
        // console.log('locationlocation',location)
      
        return location;
    } catch (error) {
        console.error('Error fetching IP details:', error);
    }
}

let apiEndpoint = "https://api.opencagedata.com/geocode/v1/json";
let apiKey = "26fc8cdd547a400eb39c9af4a510cb90";
  const getUserCurrentAddress = (locationData) => {
    const latitude = locationData.latitude;
    const longitude = locationData.longitude;

    let query = `${latitude},${longitude}`;
    let apiUrl = `${apiEndpoint}?key=${apiKey}&q=${query}&pretty=1`;

    return fetchData(apiUrl)
        .then(data => {
            // console.log(data);
            const timestamp = new Date(data.timestamp.created_unix * 1000); 
            const formattedTimestamp = timestamp.toLocaleString(undefined, { timeZone: data.results[0].annotations.timezone.name });
            // console.log("Time:", formattedTimestamp)
            return formattedTimestamp;
        })
        .catch(error => console.error('Error getting user address:', error));
};

  const fetchData = (url) => {
    return fetch(url)
        .then(response => response.json())
        .catch(error => console.error('Error fetching data:', error));
};